export const validDomain = (domain) => {
  return /^([a-zA-Z0-9\-]+\.){1,}[a-zA-Z]{2,24}$/.test(domain);
};

export default validDomain;
